import { render, staticRenderFns } from "./OrderDetailsComponent.vue?vue&type=template&id=e1fa30d0"
import script from "./OrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsComponent.vue?vue&type=style&index=0&id=e1fa30d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports